import { ADD_QUESTION_FAIL, ADD_QUESTION_REQUEST, ADD_QUESTION_SUCCESS, ADD_SECTION_FAIL, ADD_SECTION_REQUEST, ADD_SECTION_SUCCESS, DELETE_QUESTION_FAIL, DELETE_QUESTION_REQUEST, DELETE_QUESTION_SUCCESS, DELETE_SECTION_FAIL, DELETE_SECTION_MERGE_QUESTION_FAIL, DELETE_SECTION_MERGE_QUESTION_REQUEST, DELETE_SECTION_MERGE_QUESTION_SUCCESS, DELETE_SECTION_REQUEST, DELETE_SECTION_SUCCESS, DUPLICATE_QUESTION_FAIL, DUPLICATE_QUESTION_REQUEST, DUPLICATE_QUESTION_SUCCESS, DUPLICATE_SECTION_FAIL, DUPLICATE_SECTION_REQUEST, DUPLICATE_SECTION_SUCCESS, GET_SURVEY_DATA_FAIL, GET_SURVEY_DATA_REQUEST, GET_SURVEY_DATA_SUCCESS, GET_SURVEY_QUESTION_DATA_FAIL, GET_SURVEY_QUESTION_DATA_REQUEST, GET_SURVEY_QUESTION_DATA_SUCCESS, GET_SURVEY_SECTION_DATA_FAIL, GET_SURVEY_SECTION_DATA_REQUEST, GET_SURVEY_SECTION_DATA_SUCCESS, SET_SURVEY_DES, SET_SURVEY_TITLE, UPDATE_QUESTION_CONTROL_FAIL, UPDATE_QUESTION_CONTROL_REQUEST, UPDATE_QUESTION_CONTROL_SUCCESS, UPDATE_QUESTION_FAIL, UPDATE_QUESTION_HINT_FAIL, UPDATE_QUESTION_HINT_REQUEST, UPDATE_QUESTION_HINT_SUCCESS, UPDATE_QUESTION_ORDERING_FAIL, UPDATE_QUESTION_ORDERING_REQUEST, UPDATE_QUESTION_ORDERING_SUCCESS, UPDATE_QUESTION_REQUEST, UPDATE_QUESTION_SUCCESS, UPDATE_QUESTION_TEXT_FAIL, UPDATE_QUESTION_TEXT_REQUEST, UPDATE_QUESTION_TEXT_SUCCESS, UPDATE_QUESTION_TYPE_FAIL, UPDATE_QUESTION_TYPE_REQUEST, UPDATE_QUESTION_TYPE_SUCCESS, UPDATE_SECTION_DESC_FAIL, UPDATE_SECTION_DESC_REQUEST, UPDATE_SECTION_DESC_SUCCESS, UPDATE_SECTION_ORDERING_FAIL, UPDATE_SECTION_ORDERING_REQUEST, UPDATE_SECTION_ORDERING_SUCCESS, UPDATE_SECTION_TITLE_FAIL, UPDATE_SECTION_TITLE_REQUEST, UPDATE_SECTION_TITLE_SUCCESS } from "../constant"

const initialState = {
  surveyData: {
    surveyTitle: '',
    surveyDes: ''
  },
  surveyDetails: [],
  surveySectionData: [],
  surveyQuestionData: [],
}

const qnaBuilderReducer = (state = initialState, action) => {
  switch (action.type) {
    //Set survey title
    case SET_SURVEY_TITLE:
      return {
        ...state,
        surveyData: { ...state.surveyData, surveyTitle: action.payload }
      }

    //Set survey des
    case SET_SURVEY_DES:
      return {
        ...state,
        surveyData: { ...state.surveyData, surveyDes: action.payload }
      }

    //Get survey data
    case GET_SURVEY_DATA_REQUEST:
      return {
        ...state,
        surveyDetails: [],
      }
    case GET_SURVEY_DATA_SUCCESS:
      return {
        ...state,
        surveyDetails: action.payload,
      }
    case GET_SURVEY_DATA_FAIL:
      return {
        ...state,
        surveyDetails: [],
      }

    //Get survey section data
    case GET_SURVEY_SECTION_DATA_REQUEST:
      return {
        ...state,
        surveySectionData: []
      }
    case GET_SURVEY_SECTION_DATA_SUCCESS:
      const sortedSurveySectionData = action.payload?.sort((a, b) => Number(a.su_order_no ?? 0) - Number(b.su_order_no ?? 0))
      return {
        ...state,
        surveySectionData: [...sortedSurveySectionData]
      }
    case GET_SURVEY_SECTION_DATA_FAIL:
      return {
        ...state,
        surveySectionData: []
      }

    //Get survey question data
    case GET_SURVEY_QUESTION_DATA_REQUEST:
      return {
        ...state,
        surveyQuestionData: [],
      }
    case GET_SURVEY_QUESTION_DATA_SUCCESS:
      const sortedSurveyQuestionData = action.payload?.sort((a, b) => Number(a.su_order_no ?? 0) - Number(b.su_order_no ?? 0))
      return {
        ...state,
        surveyQuestionData: [...sortedSurveyQuestionData]
      }
    case GET_SURVEY_QUESTION_DATA_FAIL:
      return {
        ...state,
        surveyQuestionData: [],
      }

    //Update section title reducer
    case UPDATE_SECTION_TITLE_REQUEST:
      return {
        ...state,
      }
    case UPDATE_SECTION_TITLE_SUCCESS:

      const tmpSurveySectionDatastate = state.surveySectionData?.map((section) => {
        if (section.su_section_id === Number(action.payload?.su_section_id))
          return { ...section, su_section_name: JSON.stringify({ [action.payload?.language_code]: action.payload?.su_section_name }) }
        return section
      })

      return {
        ...state,
        surveySectionData: [...tmpSurveySectionDatastate]
      }
    case UPDATE_SECTION_TITLE_FAIL:
      return {
        ...state,
      }

    //Update section desc reducer
    case UPDATE_SECTION_DESC_REQUEST:
      return {
        ...state,
      }
    case UPDATE_SECTION_DESC_SUCCESS:
      const tmpSurveySectionData = state.surveySectionData?.map((section) => {
        if (section.su_section_id === Number(action.payload?.su_section_id))
          return { ...section, su_section_desc: JSON.stringify({ [action.payload?.language_code]: action.payload?.su_section_desc }) }
        return section
      })

      return {
        ...state,
        surveySectionData: [...tmpSurveySectionData]
      }
    case UPDATE_SECTION_DESC_FAIL:
      return {
        ...state,
      }

    //Update question reducer
    case UPDATE_QUESTION_REQUEST:
      return {
        ...state,
      }
    case UPDATE_QUESTION_SUCCESS:
      let tmpSurveyQuestionData = state.surveyQuestionData?.map((question) => {
        if (Number(question?.su_question_id) === Number(action.payload?.qid)) {
          return { ...question, su_options: JSON.stringify(action.payload?.qopts) }
        }
        return question
      })
      return {
        ...state,
        surveyQuestionData: [...tmpSurveyQuestionData]
      }
    case UPDATE_QUESTION_FAIL:
      return {
        ...state,
      }

    //Update question type reducer
    case UPDATE_QUESTION_TYPE_REQUEST:
      return {
        ...state,
      }
    case UPDATE_QUESTION_TYPE_SUCCESS:
      let tmpSurveyQuestion = state.surveyQuestionData?.map((question) => {
        if (Number(question?.su_question_id) === Number(action.payload?.question_id)) {
          return { ...question, su_question_type: action.payload?.su_question_type }
        }
        return question
      })
      return {
        ...state,
        surveyQuestionData: [...tmpSurveyQuestion]
      }
    case UPDATE_QUESTION_TYPE_FAIL:
      return {
        ...state,
      }

    //Update question control reducer
    case UPDATE_QUESTION_CONTROL_REQUEST:
      return {
        ...state,
      }
    case UPDATE_QUESTION_CONTROL_SUCCESS:
      let tmpSurveyQuestions = state.surveyQuestionData?.map((question) => {
        if (Number(question?.su_question_id) === Number(action.payload?.question_id)) {
          if (action.payload?.column === 'su_is_hint') {
            return { ...question, su_is_hint: action.payload?.value }
          }
          if (action.payload?.column === 'su_is_required') {
            return { ...question, su_is_required: action.payload?.value }
          }
          else if (action.payload?.column === 'su_is_score') {
            return { ...question, su_is_score: action.payload?.value }
          }
          else if (action.payload?.column === 'su_opinion_range') {
            return { ...question, su_opinion_range: action.payload?.value }
          } else if (action.payload?.column === 'su_opinion_icon') {
            return { ...question, su_opinion_icon: action.payload?.value }
          }
        }
        return question
      })
      return {
        ...state,
        surveyQuestionData: [...tmpSurveyQuestions]
      }
    case UPDATE_QUESTION_CONTROL_FAIL:
      return {
        ...state,
      }

    //Add section
    case ADD_SECTION_REQUEST:
      return {
        ...state,
      }
    case ADD_SECTION_SUCCESS:
      return {
        ...state,
      }
    case ADD_SECTION_FAIL:
      return {
        ...state,
      }

    //Delete section
    case DELETE_SECTION_REQUEST:
      return {
        ...state,
      }
    case DELETE_SECTION_SUCCESS:
      let tmPSurveySectionData = state.surveySectionData?.filter((section) => Number(section.su_section_id) !== Number(action.payload))
      const newQuestionsAftDelete = state.surveyQuestionData?.filter((ques) => Number(ques?.su_section_id) !== Number(action.payload))

      return {
        ...state,
        surveySectionData: [...tmPSurveySectionData],
        surveyQuestionData: [...newQuestionsAftDelete],
      }
    case DELETE_SECTION_FAIL:
      return {
        ...state,
      }

    //Delete and merge question
    case DELETE_SECTION_MERGE_QUESTION_REQUEST:
      return {
        ...state,
      }
    case DELETE_SECTION_MERGE_QUESTION_SUCCESS:
      const { targeted_section_id, section_id } = action.payload

      const tmpSections = state.surveySectionData?.filter((section) => Number(section?.su_section_id) !== Number(section_id)) ?? []
      const newQuestions = state.surveyQuestionData?.map((ques) => {
        if (Number(ques?.su_section_id) === Number(section_id)) {
          return { ...ques, su_section_id: targeted_section_id }
        }
        return ques
      })

      return {
        ...state,
        surveySectionData: [...tmpSections],
        surveyQuestionData: [...newQuestions],
      }
    case DELETE_SECTION_MERGE_QUESTION_FAIL:
      return {
        ...state,
      }

    //Delete question
    case DELETE_QUESTION_REQUEST:
      return {
        ...state,
      }
    case DELETE_QUESTION_SUCCESS:
      let tmPSurveyQuestionData = state.surveyQuestionData?.filter((question) => {
        return Number(question.su_question_id) !== Number(action.payload)
      })

      return {
        ...state,
        surveyQuestionData: [...tmPSurveyQuestionData],
      }
    case DELETE_QUESTION_FAIL:
      return {
        ...state,
      }

    //Duplicate section
    case DUPLICATE_SECTION_REQUEST:
      return {
        ...state,
      }
    case DUPLICATE_SECTION_SUCCESS:
      const { section_id: new_section_id, questions, old_section_id } = action.payload
      const duplicatedSection = state.surveySectionData?.filter((section) => Number(section?.su_section_id) === Number(old_section_id))[0] ?? []
      const newSection = { ...duplicatedSection, su_section_id: new_section_id, su_section_modified_date_time: null, su_section_created_date_time: null }
      return {
        ...state,
        surveySectionData: [...state.surveySectionData, newSection],
        surveyQuestionData: [...state.surveyQuestionData, ...questions],
      }
    case DUPLICATE_SECTION_FAIL:
      return {
        ...state,
      }

    //Duplicate question
    case DUPLICATE_QUESTION_REQUEST:
      return {
        ...state,
      }
    case DUPLICATE_QUESTION_SUCCESS:
      const { new_question_id, question_id } = action.payload
      const duplicatedQuestion = state.surveyQuestionData?.filter((ques) => Number(ques?.su_question_id) === Number(question_id))[0] ?? []
      const question = { ...duplicatedQuestion, su_question_id: new_question_id }

      return {
        ...state,
        surveyQuestionData: [...state.surveyQuestionData, question],
      }
    case DUPLICATE_QUESTION_FAIL:
      return {
        ...state,
      }

    //Add question
    case ADD_QUESTION_REQUEST:
      return {
        ...state,
      }
    case ADD_QUESTION_SUCCESS:
      return {
        ...state,
      }
    case ADD_QUESTION_FAIL:
      return {
        ...state,
      }

    //Update section ordering
    case UPDATE_SECTION_ORDERING_REQUEST:
      return {
        ...state,
      }
    case UPDATE_SECTION_ORDERING_SUCCESS:
      const orderingData = action.payload
      const updatedData = state.surveySectionData?.map((section) => {
        const tmpSection = { ...section }
        Object.keys(orderingData ?? {})?.forEach((sectionID) => {
          if (Number(sectionID) === Number(tmpSection.su_section_id)) {
            tmpSection.su_order_no = orderingData[sectionID]
          }
        })
        return tmpSection
      })
      const sortedData = updatedData?.sort((a, b) => Number(a.su_order_no ?? 0) - Number(b.su_order_no ?? 0))
      return {
        ...state,
        surveySectionData: [...sortedData],
      }
    case UPDATE_SECTION_ORDERING_FAIL:
      return {
        ...state,
      }

    //Update question ordering
    case UPDATE_QUESTION_ORDERING_REQUEST:
      return {
        ...state,
      }
    case UPDATE_QUESTION_ORDERING_SUCCESS:
      const orderingDataQues = action.payload
      const updatedDataQues = state.surveyQuestionData?.map((question) => {
        const tmpquestion = { ...question }
        Object.keys(orderingDataQues ?? {})?.forEach((questionId) => {
          if (Number(questionId) === Number(tmpquestion.su_question_id)) {
            tmpquestion.su_order_no = orderingDataQues[questionId]
          }
        })
        return tmpquestion
      })
      const sortedDataQues = updatedDataQues?.sort((a, b) => Number(a.su_order_no ?? 0) - Number(b.su_order_no ?? 0))
      return {
        ...state,
        surveyQuestionData: [...sortedDataQues],
      }
    case UPDATE_QUESTION_ORDERING_FAIL:
      return {
        ...state,
      }

    //Update question text
    case UPDATE_QUESTION_TEXT_REQUEST:
      return {
        ...state,
      }
    case UPDATE_QUESTION_TEXT_SUCCESS:
      let data = action.payload
      let tmpSurveyQuestionsData = state.surveyQuestionData?.map((question) => {
        let tmpQue = { ...question }
        if (Number(question.su_question_id) === Number(data?.id)) {
          tmpQue = { ...tmpQue, su_question_text: JSON.stringify({ [data.language_code]: data.text }) }
        }
        return tmpQue
      })

      return {
        ...state,
        surveyQuestionData: [...tmpSurveyQuestionsData],
      }
    case UPDATE_QUESTION_TEXT_FAIL:
      return {
        ...state,
      }

    //Update question text
    case UPDATE_QUESTION_HINT_REQUEST:
      return {
        ...state,
      }
    case UPDATE_QUESTION_HINT_SUCCESS:
      let hintData = action.payload
      let tmpSurveyQueData = state.surveyQuestionData?.map((question) => {
        let tmpQue = { ...question }
        if (Number(question.su_question_id) === Number(hintData?.id)) {
          tmpQue = { ...tmpQue, su_question_hint: JSON.stringify({ [hintData.language_code]: hintData.text }) }
        }
        return tmpQue
      })

      return {
        ...state,
        surveyQuestionData: [...tmpSurveyQueData],
      }
    case UPDATE_QUESTION_HINT_FAIL:
      return {
        ...state,
      }


    //Default
    default:
      return state;
  }
}

export { qnaBuilderReducer }